// Static data for records table
export const recordsData = [
  {
    id: 1,
    cancelledBy: {
      name: "John Smith",
      code: "F3R4ZVAUR",
      initials: "JS",
      avatarColor: "teal",
    },
    cancelledOn: { date: "10 Jun 25", time: "14:30" },
    reason: "Found a better deal elsewhere",
    clientPaid: "£50.00",
    jobType: "House Move",
    scheduledFor: { date: "15 Jun 25", time: "09:00" },
    timeFromJob: "4d before",
    accountAge: "1 year, 9 months, 13 days",
  },
  {
    id: 2,
    cancelledBy: {
      name: "Sarah Williams",
      code: "Z816ASDFG",
      initials: "SW",
      avatarColor: "teal",
    },
    cancelledOn: { date: "8 Jun 25", time: "09:15" },
    reason: "No longer need the service",
    clientPaid: "£35.00",
    jobType: "Send Items",
    scheduledFor: { date: "9 Jun 25", time: "13:30" },
    timeFromJob: "1d before",
    accountAge: "9 months, 1 day",
  },
  {
    id: 3,
    cancelledBy: {
      name: "Emma Davis",
      code: "M2T3QWERT",
      initials: "ED",
      avatarColor: "gray",
    },
    cancelledOn: { date: "5 Jun 25", time: "16:45" },
    reason: "Change of plans, moving date postponed",
    clientPaid: "£75.00",
    jobType: "House Move",
    scheduledFor: { date: "12 Jun 25", time: "10:00" },
    timeFromJob: "6d before",
    accountAge: "2 years, 11 months, 7 days",
  },
  {
    id: 4,
    cancelledBy: {
      name: "Mike Johnson",
      code: "K9P7XBCDE",
      initials: "MJ",
      avatarColor: "blue",
    },
    cancelledOn: { date: "3 Jun 25", time: "11:20" },
    reason: "Vehicle breakdown - unable to complete job",
    clientPaid: "£25.00",
    jobType: "Waste Disposal",
    scheduledFor: { date: "2 Jun 25", time: "14:00" },
    timeFromJob: "21h after",
    accountAge: "1 year, 10 months, 13 days",
  },
  {
    id: 5,
    cancelledBy: {
      name: "Sophia Martin",
      code: "H6G5F4D3S",
      initials: "SM",
      avatarColor: "teal",
    },
    cancelledOn: { date: "30 May 25", time: "08:10" },
    reason: "Items no longer need to be sent",
    clientPaid: "£40.00",
    jobType: "Send Items",
    scheduledFor: { date: "1 Jun 25", time: "11:30" },
    timeFromJob: "2d before",
    accountAge: "1 year, 10 months, 13 days",
  },
  {
    id: 6,
    cancelledBy: {
      name: "Jacob Anderson",
      code: "J991BG7FG3",
      initials: "JA",
      avatarColor: "orange",
    },
    cancelledOn: { date: "28 May 25", time: "13:05" },
    reason: "Found alternative service",
    clientPaid: "£60.00",
    jobType: "House Move",
    scheduledFor: { date: "27 May 25", time: "09:15" },
    timeFromJob: "1d after",
    accountAge: "1 year, 10 months, 13 days",
  },
  {
    id: 7,
    cancelledBy: {
      name: "Mia Thompson",
      code: "M224P9Q2L",
      initials: "MT",
      avatarColor: "purple",
    },
    cancelledOn: { date: "25 May 25", time: "15:40" },
    reason: "Waste disposal no longer needed",
    clientPaid: "£30.00",
    jobType: "Waste Disposal",
    scheduledFor: { date: "26 May 25", time: "16:00" },
    timeFromJob: "19h before",
    accountAge: "1 year, 10 months, 13 days",
  },
  {
    id: 8,
    cancelledBy: {
      name: "Daniel Clark",
      code: "D8K2L9MNP",
      initials: "DC",
      avatarColor: "green",
    },
    cancelledOn: { date: "22 May 25", time: "10:25" },
    reason: "Unexpected travel plans",
    clientPaid: "£55.00",
    jobType: "House Move",
    scheduledFor: { date: "24 May 25", time: "08:45" },
    timeFromJob: "2d before",
    accountAge: "3 years, 2 months, 5 days",
  },
  {
    id: 9,
    cancelledBy: {
      name: "Olivia Brown",
      code: "O9L8K7J6H",
      initials: "OB",
      avatarColor: "pink",
    },
    cancelledOn: { date: "20 May 25", time: "17:50" },
    reason: "Booking created by mistake",
    clientPaid: "£20.00",
    jobType: "Send Items",
    scheduledFor: { date: "21 May 25", time: "12:15" },
    timeFromJob: "18h before",
    accountAge: "8 months, 14 days",
  },
  {
    id: 10,
    cancelledBy: {
      name: "Ethan Walker",
      code: "E5R6T7Y8U",
      initials: "EW",
      avatarColor: "red",
    },
    cancelledOn: { date: "18 May 25", time: "07:35" },
    reason: "Service provider unavailable",
    clientPaid: "£90.00",
    jobType: "Waste Disposal",
    scheduledFor: { date: "19 May 25", time: "15:00" },
    timeFromJob: "1d before",
    accountAge: "2 years, 4 months, 18 days",
  },
  {
    id: 11,
    cancelledBy: {
      name: "Ava Wilson",
      code: "A1B2C3D4E",
      initials: "AW",
      avatarColor: "cyan",
    },
    cancelledOn: { date: "16 May 25", time: "12:20" },
    reason: "Delay in moving schedule",
    clientPaid: "£65.00",
    jobType: "House Move",
    scheduledFor: { date: "18 May 25", time: "09:45" },
    timeFromJob: "2d before",
    accountAge: "1 year, 3 months, 10 days",
  },
  {
    id: 12,
    cancelledBy: {
      name: "Liam Harris",
      code: "L8M7N6B5V",
      initials: "LH",
      avatarColor: "yellow",
    },
    cancelledOn: { date: "14 May 25", time: "18:00" },
    reason: "Incorrect booking details",
    clientPaid: "£28.00",
    jobType: "Send Items",
    scheduledFor: { date: "15 May 25", time: "11:20" },
    timeFromJob: "17h before",
    accountAge: "6 months, 21 days",
  },
  {
    id: 13,
    cancelledBy: {
      name: "Charlotte King",
      code: "C4V5B6N7M",
      initials: "CK",
      avatarColor: "indigo",
    },
    cancelledOn: { date: "12 May 25", time: "09:10" },
    reason: "Duplicate booking submitted",
    clientPaid: "£48.00",
    jobType: "Waste Disposal",
    scheduledFor: { date: "13 May 25", time: "14:40" },
    timeFromJob: "1d before",
    accountAge: "2 years, 6 months, 2 days",
  },
  {
    id: 14,
    cancelledBy: {
      name: "Noah Lewis",
      code: "N5H6J7K8L",
      initials: "NL",
      avatarColor: "lime",
    },
    cancelledOn: { date: "10 May 25", time: "20:30" },
    reason: "Moved service to another date",
    clientPaid: "£70.00",
    jobType: "House Move",
    scheduledFor: { date: "14 May 25", time: "08:00" },
    timeFromJob: "4d before",
    accountAge: "4 years, 1 month, 15 days",
  },
  {
    id: 15,
    cancelledBy: {
      name: "Isabella Moore",
      code: "I9U8Y7T6R",
      initials: "IM",
      avatarColor: "rose",
    },
    cancelledOn: { date: "8 May 25", time: "06:55" },
    reason: "Personal emergency",
    clientPaid: "£85.00",
    jobType: "Send Items",
    scheduledFor: { date: "9 May 25", time: "10:30" },
    timeFromJob: "1d before",
    accountAge: "3 years, 7 months, 11 days",
  },
];

export const periodButtons = [
  { id: "custom", label: "Custom range" },
  { id: "7D", label: "7D" },
  { id: "30D", label: "30D" },
  { id: "3M", label: "3M" },
  { id: "6M", label: "6M" },
  { id: "12M", label: "12M" },
];

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
